import React from "react";
import { FeatureFlagRouteGuard } from "../components/shared/route-guards/FeatureFlagRouteGuard";

// Lazy-load route components to reduce initial bundle and improve TTI/TBT
const AboutUs = React.lazy(() => import("../components/pages/about-us/AboutUs"));
const HowItWorksPage = React.lazy(() =>
  import("../components/pages/how-it-works/HowItWorksPage"),
);
const CookiePolicy = React.lazy(() =>
  import("../components/pages/agreements/CookiePolicy").then((m) => ({ default: m.CookiePolicy }))
);
const Disclaimer = React.lazy(() =>
  import("../components/pages/agreements/Disclaimer").then((m) => ({ default: m.Disclaimer }))
);
const PrivacyPolicy = React.lazy(() =>
  import("../components/pages/agreements/PrivacyPolicy").then((m) => ({ default: m.PrivacyPolicy }))
);
const TermsAndConditions = React.lazy(() =>
  import("../components/pages/agreements/TermsAndConditions").then((m) => ({ default: m.TermsAndConditions }))
);
const TermsOfUse = React.lazy(() =>
  import("../components/pages/agreements/TermsOfUse").then((m) => ({ default: m.TermsOfUse }))
);
const BrowseFreelancersPage = React.lazy(() =>
  import("../components/pages/browse-freelancers/BrowseFreelancersPage")
);
const FreelancerProfilePage = React.lazy(() =>
  import("../components/pages/browse-freelancers/FreelancerProfilePage")
);
const BrowseProjectsPage = React.lazy(() =>
  import("../components/pages/browse-projects/BrowseProjectPage")
);
const BusinessTab = React.lazy(() =>
  import("../components/pages/business-tab/BusinessTab").then((m) => ({ default: m.BusinessTab }))
);
const MenaCoursesPage = React.lazy(() =>
  import("../components/pages/business-tab/sell-mena-course/MenaCoursesPage").then((m) => ({ default: m.MenaCoursesPage }))
);
const BrowseCourses = React.lazy(() =>
  import("../components/pages/courses/BrowseCourses")
);
const FreelancersTab = React.lazy(() =>
  import("../components/pages/freelancers-tab/FreelancersTab").then((m) => ({ default: m.FreelancersTab }))
);
const HealthCheck = React.lazy(() => import("../components/pages/health-checker/HealthCheck"));
const Hompage = React.lazy(() =>
  import("../components/pages/homepage/Hompage").then((m) => ({ default: m.Hompage }))
);
const JobListing = React.lazy(() =>
  import("../components/pages/job-listing/JobListing").then((m) => ({ default: m.JobListing }))
);
const LiberLogin = React.lazy(() => import("../components/pages/liber-login/LiberLogin"));
const Signup = React.lazy(() =>
  import("../components/pages/signup").then((m) => ({ default: m.Signup }))
);
const VerifyPage = React.lazy(() =>
  import("../components/pages/user-management/VerifyPage").then((m) => ({ default: m.VerifyPage }))
);
const WorkshopPage = React.lazy(() => import("../components/pages/workshop-page/WorkshopPage"));
const ForgotPasswordPage = React.lazy(() => import("../components/pages/auth/ForgotPasswordPage"));
const ResetPasswordPage = React.lazy(() => import("../components/pages/auth/ResetPasswordPage"));
const PricingPage = React.lazy(() => import("../components/pages/pricing/PricingPage"));
const HelpCenterPage = React.lazy(() => import("../components/pages/help-center/HelpCenterPage"));
const BlogListPage = React.lazy(() => import("../components/pages/blog/BlogListPage"));
const BlogPostPage = React.lazy(() => import("../components/pages/blog/BlogPostPage"));

function withFeatureFlag(flag, Component) {
  const Wrapped = () => (
    <FeatureFlagRouteGuard flag={flag}>
      <Component />
    </FeatureFlagRouteGuard>
  );
  return Wrapped;
}

export const PUBLIC_ROUTES = [
  { path: "/", element: Hompage },
  { path: "/login", element: LiberLogin },
  { path: "/admin/login", element: LiberLogin },
  { path: "/sign-up", element: Signup },
  { path: "/home", element: Hompage },
  { path: "/freelancers-tab", element: FreelancersTab },
  { path: "/business-tab", element: BusinessTab },
  { path: "/workshop", element: WorkshopPage },
  { path: "/about-us", element: AboutUs },
  { path: "/how-it-works", element: HowItWorksPage },
  { path: "/pricing", element: PricingPage },
  { path: "/help-center", element: HelpCenterPage },
  { path: "/blog", element: BlogListPage },
  { path: "/blog/:slug", element: BlogPostPage },
  { path: "/job-listings", element: JobListing },
  { path: "health", element: HealthCheck },
  { path: "/verify", element: VerifyPage },
  { path: "liber-learn", element: withFeatureFlag("courses", MenaCoursesPage) },
  { path: "/browse-freelancers", element: withFeatureFlag("browseFreelancers", BrowseFreelancersPage) },
  { path: "/browse-freelancers/:slug", element: withFeatureFlag("browseFreelancers", FreelancerProfilePage) },
  { path: "/browse-projects", element: withFeatureFlag("browseProjects", BrowseProjectsPage) },
  { path: "/browse-courses", element: withFeatureFlag("courses", BrowseCourses) },
  { path: "/terms-and-conditions", element: TermsAndConditions },
  { path: "/cookie-policy", element: CookiePolicy },
  { path: "/disclaimer", element: Disclaimer },
  { path: "/privacy-policy", element: PrivacyPolicy },
  { path: "/terms-of-use", element: TermsOfUse },
  { path: "/forgot-password", element: ForgotPasswordPage },
  { path: "/reset-password", element: ResetPasswordPage },
];
